import React, { useState, useEffect } from 'react';
import { FiX, FiBell, FiAlertCircle, FiCheckCircle } from 'react-icons/fi';
import './AnnouncementModal.css';

const AnnouncementModal = ({ 
  isOpen, 
  onClose, 
  announcement = null,
  autoShow = true 
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [hasBeenShown, setHasBeenShown] = useState(false);

  // 默认公告内容
  const defaultAnnouncement = {
    "id": "v1.0.0",
    "type": "success",
    "title": "系统更新通知",
    "content": "默认公告",
    "version": "1.0.0",
    date: new Date().toLocaleDateString('zh-CN'),
    showOnce: false
  };

  const currentAnnouncement = announcement || defaultAnnouncement;

  useEffect(() => {
    if (autoShow && !hasBeenShown) {
      // 检查是否已经显示过这个公告
      const shownAnnouncements = JSON.parse(localStorage.getItem('shownAnnouncements') || '[]');
      if (currentAnnouncement.showOnce && shownAnnouncements.includes(currentAnnouncement.id)) {
        return;
      }
      
      // 延迟显示公告
      const timer = setTimeout(() => {
        setIsVisible(true);
        setHasBeenShown(true);
      }, 1000);
      
      return () => clearTimeout(timer);
    }
  }, [autoShow, hasBeenShown, currentAnnouncement]);

  useEffect(() => {
    if (isOpen !== undefined) {
      setIsVisible(isOpen);
    }
  }, [isOpen]);

  const handleClose = () => {
    setIsVisible(false);
    
    // 记录已显示的公告
    if (currentAnnouncement.showOnce) {
      const shownAnnouncements = JSON.parse(localStorage.getItem('shownAnnouncements') || '[]');
      if (!shownAnnouncements.includes(currentAnnouncement.id)) {
        shownAnnouncements.push(currentAnnouncement.id);
        localStorage.setItem('shownAnnouncements', JSON.stringify(shownAnnouncements));
      }
    }
    
    if (onClose) {
      onClose();
    }
  };

  const getIcon = () => {
    switch (currentAnnouncement.type) {
      case 'success':
        return <FiCheckCircle />;
      case 'warning':
        return <FiAlertCircle />;
      case 'error':
        return <FiAlertCircle />;
      default:
        return <FiBell />;
    }
  };

  if (!isVisible) return null;

  return (
    <div className="announcement-overlay" onClick={handleClose}>
      <div 
        className={`announcement-modal announcement-${currentAnnouncement.type}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="announcement-header">
          <div className="announcement-icon">
            {getIcon()}
          </div>
          <h3 className="announcement-title">{currentAnnouncement.title}</h3>
          <button className="announcement-close" onClick={handleClose}>
            <FiX />
          </button>
        </div>
        
        <div className="announcement-body">
          <div className="announcement-content">
            {currentAnnouncement.content}
          </div>
          
          {currentAnnouncement.version && (
            <div className="announcement-version">
              版本: {currentAnnouncement.version}
            </div>
          )}
          
          <div className="announcement-date">
            {currentAnnouncement.date}
          </div>
        </div>
        
        <div className="announcement-footer">
          <button className="announcement-btn" onClick={handleClose}>
            我知道了
          </button>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementModal;